import AsyncTaskQueue from "@/lib/queue/async-queue";

export const queue = new AsyncTaskQueue<HTMLImageElement>({
  interval: 1000,
  intervalLimit: 8,
  concurrencyLimit: 6,
});
